module.exports = __webpack_public_path__ + "static/media/ResyHero_1920x450-4.5bae3bee.png";